import { CloseRounded } from "@mui/icons-material";
import { Divider, IconButton, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Tabs } from "layout";
import { action, API, controller } from "api";
import { useNavigate } from "react-router-dom";
import RegFormBody from "./RegFormBody";
import { AppContext } from "App";
import { lsGet } from "hooks";

const RegisterForm = (props) => {
  const { setShowForm, regCloseable = true, onSuccess } = props;
  const navigate = useNavigate();
  const activeReg = lsGet("activeReg");
  const { authUser } = useContext(AppContext);
  const [activeTab, setActiveTab] = useState(0);
  const [outlets, setOutlets] = useState([]);

  useEffect(() => {
    if (authUser && authUser.id) {
      API(controller.Outlet + action.GetOutletsWithRegisters).get((res) => {
        res.status === 200 &&
          setOutlets([
            ...res.result.map((j) => ({ ...j, label: j.outletName, icon: "" })),
          ]);
      });
    }
    return () => {};
  }, [authUser]);

  // Select the active outlet for the tabs
  useEffect(() => {
    if (activeReg && activeReg.outletId && outlets.length > 0)
      setActiveTab(outlets.findIndex((j) => j.id === activeReg.outletId));
    else setActiveTab(0);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outlets]);

  const handleClose = () => {
    if (regCloseable) {
      setShowForm(false);
    } else {
      navigate("/home");
    }
  };

  return (
    <Paper>
      {/* Header */}
      <div className="flex flex-wrap justify-between items-center p-[8px] min-w-[320px]">
        <span className="font-medium text-[18px] uppercase text-gray-500 ml-[8px]">
          Register
        </span>

        <IconButton size="small" onClick={handleClose}>
          <CloseRounded />
        </IconButton>
      </div>
      <Divider />

      {/* Body */}
      {outlets.length > 0 && (
        <div className="mt-[10px]">
          <Tabs
            active={activeTab}
            header={[...outlets]}
            className="m-[15px] mb-0"
          >
            {outlets.map((outlet, ind) => (
              <div key={ind}>
                {outlet.registers && outlet.registers.length > 0 ? (
                  <RegFormBody
                    {...{
                      regs: outlet.registers,
                      outletId: outlet.id,
                      setShowForm,
                      onSuccess,
                    }}
                  />
                ) : (
                  <span className="block font-medium text-[22px] text-center p-[20px] text-gray-400">
                    No Regsiter Found
                  </span>
                )}
              </div>
            ))}
          </Tabs>
        </div>
      )}
    </Paper>
  );
};

export default RegisterForm;
